<div class="list-container">
  @for (screeningResult of screening().results; track $index) {
    @let isValid = screeningResult.status === 'fulfilled';
    @let isInvalid = screeningResult.status === 'unfulfilled';
    @let isExpanded = expandedMap()[screeningResult.id];

    <div class="row">
      <div class="row-header">
        <rt-icon
          [name]="statusIconMap[screeningResult.status]"
          [colorToken]="isValid ? 'colorIconPrimaryDefault' : 'colorIconLowDefault'"
        />
        @if (!expandable()) {
          <span [class.invalid]="isInvalid">
            {{ screeningResult.criterionName }}
          </span>
        } @else {
          <div (click)="toggleExpand(screeningResult.id)" class="row-clickable">
            <span [class.invalid]="isInvalid"> {{ screeningResult.criterionName }} </span>
            <rt-icon [name]="isExpanded ? 'expand-less' : 'expand-more'" size="small" />
          </div>
        }
      </div>
      @if (expandable()) {
        @if (isExpanded) {
          <div class="expanded">
            {{ screeningResult.reason }}
            <div class="actions">
              <rt-button
                size="small"
                variant="plain"
                [disabled]="disableEdit()"
                (click)="edit.emit(screeningResult)"
              >
                {{ 'app.ai_candidate_screening.results.edit_manually' | translate }}
              </rt-button>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
